import React from "react";
import { Typography } from "@material-ui/core";

import Modal from "../../../components/dialogs/modal";

interface DeleteUserModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  t: (key: string) => string;
}

const DeleteUserModal = ({
  visible,
  onOk,
  onCancel,
  t
}: DeleteUserModalProps) => (
  <Modal
    open={visible}
    title={t("common.messages.areYouSure")}
    actions={[
      {
        text: t("common.ok"),
        type: "ok",
        action: onOk
      },
      {
        text: t("common.cancel"),
        type: "cancel",
        action: onCancel
      }
    ]}
  >
    <Typography>
      This will delete the user footprint in the system, making it impossible to
      track afterwards.
    </Typography>
  </Modal>
);

export default DeleteUserModal;
